/*
  Alpha Zen redesign, product page.

  Two small jobs, both taken from pdp.html:

  1. The thumbnail strip swaps the main image and carries its alt text across.
  2. The per-bottle line under the price follows the selected pack. The figures
     themselves are computed in Liquid from each variant's price and handed over
     on the radio inputs as data-az-per, so nothing is recalculated here. Dawn
     re-renders the price itself on variant change; this only keeps the line
     under it honest.
*/
(function () {
  function initGallery(root) {
    root.querySelectorAll('[data-az-galmain]').forEach(function (frame) {
      if (frame.dataset.azReady === 'true') return;
      frame.dataset.azReady = 'true';

      const gallery = frame.closest('.gal');
      const main = frame.querySelector('img');
      if (!gallery || !main) return;

      gallery.querySelectorAll('[data-az-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          const source = thumb.querySelector('img');
          if (!source) return;

          main.src = source.currentSrc || source.src;
          main.removeAttribute('srcset');
          main.alt = thumb.dataset.azAlt || '';

          gallery.querySelectorAll('[data-az-thumb]').forEach(function (other) {
            other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  function syncPerBottle(root) {
    const line = root.querySelector('[data-az-perline]');
    if (!line) return;

    const checked = root.querySelector('.az-pill-input:checked');
    const value = checked ? checked.dataset.azPer : '';
    const target = line.querySelector('[data-az-per-value]');

    if (value) {
      line.hidden = false;
      if (target) target.textContent = value;
    } else {
      line.hidden = true;
    }
  }

  function initPacks(root) {
    root.querySelectorAll('.az-pdp').forEach(function (pdp) {
      if (pdp.dataset.azPacksReady === 'true') return;
      pdp.dataset.azPacksReady = 'true';

      syncPerBottle(pdp);
      pdp.addEventListener('change', function (event) {
        if (event.target.classList.contains('az-pill-input')) syncPerBottle(pdp);
      });
    });
  }

  function init(root) {
    const scope = root || document;
    initGallery(scope);
    initPacks(scope);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
